var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9343 3.31981C12.0078 2.24465 13.7484 2.24333 14.8219 3.31686L16.4309 4.92591C17.4953 5.99028 17.5057 7.71402 16.4543 8.7928L9.13832 16.299C8.43217 17.0235 7.46376 17.4321 6.45282 17.4321L4.6302 17.432C3.35162 17.4319 2.33107 16.3666 2.38484 15.0882L2.46417 13.2022C2.50369 12.2626 2.89436 11.3719 3.55879 10.7065L10.9343 3.31981ZM13.7616 4.37873C13.2737 3.89076 12.4825 3.89136 11.9945 4.38007L10.9332 5.443L14.3222 8.83203L15.3813 7.74545C15.8592 7.2551 15.8545 6.47158 15.3707 5.98777L13.7616 4.37873ZM4.61905 11.7667L9.87295 6.50486L13.2748 9.90672L8.06532 15.2517C7.64163 15.6864 7.06058 15.9315 6.45402 15.9315L4.6314 15.9314C4.20521 15.9314 3.86502 15.5763 3.88295 15.1502L3.96228 13.2641C3.98599 12.7004 4.22039 12.166 4.61905 11.7667ZM17.0933 17.371C17.5074 17.371 17.843 17.0351 17.843 16.6207C17.843 16.2063 17.5074 15.8704 17.0933 15.8704H11.9919C11.5778 15.8704 11.2422 16.2063 11.2422 16.6207C11.2422 17.0351 11.5778 17.371 11.9919 17.371H17.0933Z",
    fill: "#0869FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.417c4228c89d55b829ab4f7fe892a807.svg";
export { ForwardRef as ReactComponent };